import apiClient from 'ps-components/lib/apiClient';
import { useAppState } from "../redux"
import { useMutation } from 'react-query'
import { notifications } from '@mantine/notifications'

type MutationPayload = {
  categoryCode: 'market_pricing_versions_matches' | 'market_pricing_versions_summaries'
  versionIds: number[]
  includeOfficialPricing: boolean
}

async function startPoll(fileResult: any, csrfPair: { csrf_token: string; csrf_timestamp: number }): Promise<void> {
  return new Promise((resolve, reject) => {
    const POLL_INTERVAL = 2000;
    const MAX_POLL_TIME = 360000;

    const pollUrl = fileResult.pollUrl.substring(fileResult.pollUrl.indexOf('/api/'));
    let pollTime = 0;
    const pollInterval = setInterval(async () => {
      let pollResult;
      try {
        pollResult = await apiClient.apiGet(pollUrl);
      } catch (e) {
        clearInterval(pollInterval);
        console.error(e);
        reject(e);
      }
      if (pollResult.data.ready === true) {
        clearInterval(pollInterval);
        resolve();
        const { subsite } = window.app;
        window.location.href = `${window.location.origin}/${subsite}/api/generic-utils/generic-download/downloadGeneric?pretty_name=${fileResult.resultFileName}&file_name=${fileResult.resultFileName + '.xlsx'}&download_type=xlsx&csrf_token=${csrfPair.csrf_token}&csrf_timestamp=${csrfPair.csrf_timestamp}`;
      } else if (pollTime > MAX_POLL_TIME) {
        clearInterval(pollInterval);
        reject('max timeout reached');
      }
      pollTime += POLL_INTERVAL;
    }, POLL_INTERVAL);
  });
}

export const useGenerateReport = () => {
  const appState = useAppState()
  const { session: { csrfPair } } = appState

  const generateReport = async ({ categoryCode, versionIds, includeOfficialPricing }: MutationPayload): Promise<void> => {
    const reportResponse = await apiClient.apiGet(`/api/market-pricing/global-job-pricing/generateReport?categoryCode=${categoryCode}`)

    const { reportPk, categoryPk } = reportResponse.data
    const reportParams: any = {};
    if (versionIds.length) {
      reportParams["pricing_versions"] = versionIds;
    }

    reportParams["include_official_pricing"] = includeOfficialPricing;

    const downloadResultsResponse = await apiClient.apiGet(`/api/generic-grid/query/downloadResults?report_pk=${reportPk}&category_pk=${categoryPk}&downloadMode=xlsx&downloadFileName=${categoryCode}&params=${JSON.stringify(reportParams)}`);
    const fileResult = downloadResultsResponse.data

    await startPoll(fileResult, csrfPair);
  }

  const mutation = useMutation(generateReport, {
    onError: () => {
      notifications.show({ title: 'Error', message: 'Failed generating report.', color: 'red' })
    },
    onSuccess: () => {
      notifications.show({ title: 'Success', message: 'Report has successfully been downloaded' })
    }
  })

  return mutation
}


